module.exports = __webpack_public_path__ + "img/choose-1.d16805a9.png";